import { startOfDay } from "date-fns"import { endOfDay } from "date-fns"
import { parse } from "date-fns"
<template>
  <content-box v-show="!isConfirming" :width="'666px'">
    <section class="page_management__detail">
      <button type="button" class="btn-close"
              @click="$emit('onCancel')">
        <i class="icon icon--close-btn"></i>
      </button>
      <div class="detail__header">
        <h4>{{ $t('userInfo.pageManagement.detail.title') }}</h4>
      </div>
      <div class="detail__body" :class="browserInfo.name">
        <div>
          <div class="input--wrap" :class="{ w33p: !isEditMode, w50p: isEditMode}">
            <label>{{ $t('page.registration.step2.labelPage.label') }}</label>
            <div class="input ellipsis"
                 :class="{readonly: isEditMode}"
                 :title="apply.pageName">{{ apply.pageName }}</div>
          </div>
          <div class="input--wrap" :class="{ w66p: !isEditMode, w50p: isEditMode}">
            <label>{{ $t('page.registration.step2.labelGroup.label') }}</label>
            <div class="input ellipsis"
                 :class="{readonly: isEditMode}"
                 :title="apply.category">{{ apply.category }}</div>
          </div>
        </div>
        <div>
          <div class="input--wrap w33p">
            <label>{{ $t('page.registration.step1.labelMatchType') }}</label>
            <div class="input ellipsis">
              {{ $t(`page.registration.guide.step1.${apply.matchType}.title`) }}</div>
          </div>
          <div class="input--wrap w66p">
            <label>{{ $t('common.matchType.urlLabel') }}</label>
            <div class="input ellipsis"
                 :class="{readonly: isEditMode}"
                 :title="apply.url">{{ apply.url }}</div>
          </div>
        </div>
        <div class="line"></div>
        <div class="input--wrap">
          <label>{{ $t('page.registration.step1.setURL.label2') }}</label>
          <div v-if="apply.captureURL"
               class="input ellipsis"
               :class="{readonly: isEditMode}"
               :title="apply.captureURL">{{ apply.captureURL }}</div>
          <div v-else
               class="input placeholder"
               :class="{readonly: isEditMode}">{{ $t('common.placeHolder.notSet') }}</div>
        </div>
        <div class="input--wrap">
          <label>{{ $t('page.registration.optional.capture.title') }}</label>
          <div v-if="apply.exceptionSelector"
               class="input ellipsis"
               :class="{readonly: isEditMode}"
               :title="apply.exceptionSelector">{{ apply.exceptionSelector }}</div>
          <div v-else
               class="input placeholder"
               :class="{readonly: isEditMode}">{{ $t('common.placeHolder.notSet') }}</div>
        </div>
        <div>
          <div class="input--wrap w50p single-line">
            <label>{{ $t('page.registration.step1.bLogin.label2') }}</label>
            <div class="input" v-if="!isEditMode" v-html="$t('common.' + (apply.bLogin ? 'yes' : 'no'))"></div>
            <div class="input" v-else>
              <i class="icon disabled" :class="{ 'icon--radio-on': apply.bLogin, 'icon--radio-off': !apply.bLogin }"></i>
              {{$t('common.yes')}}
              &nbsp;&nbsp;
              <i class="icon disabled" :class="{ 'icon--radio-on': !apply.bLogin, 'icon--radio-off': apply.bLogin }"></i>
              {{$t('common.no')}}
            </div>
          </div>
          <div class="input--wrap w50p single-line">
            <label>{{ $t('page.registration.step1.device.label2') }}</label>
            <div class="input" v-if="!isEditMode" v-html="$t('common.' + (apply.bMobile ? 'yes' : 'no'))"></div>
            <div class="input" v-else>
              <i class="icon disabled" :class="{ 'icon--radio-on': apply.bMobile, 'icon--radio-off': !apply.bMobile }"></i>
              {{$t('common.yes')}}
              &nbsp;&nbsp;
              <i class="icon disabled" :class="{ 'icon--radio-on': !apply.bMobile, 'icon--radio-off': apply.bMobile }"></i>
              {{$t('common.no')}}
            </div>
          </div>
          <div class="input--wrap w50p">
            <label>{{ $t('page.registration.optional.report.pvLimit.label') }}</label>
            <div class="input" v-if="!isEditMode">
              <span v-if="apply.pvLimit > 0">{{ apply.pvLimit | thousand }}</span>
              <span v-else>{{ $t('common.noLimit') }}</span>
            </div>
            <div v-else>
              <ui-selectbox :value="internalPvLimit"
                            :items="pvLimitOptionList"
                            :width="'100%'"
                            @input="onPVLimitChange($event)" />
              <p v-if="internalPvLimit === 0" class="custom-input--wrap">
                <input id="customPvLimit" type="number" min="1"
                       v-model.number="customPvLimit"
                       @blur="checkCustomPvLimit"> PV
              </p>
            </div>
          </div>
          <div class="input--wrap w50p">
            <label for="timezone">{{ $t('common.timezone') }}</label>
            <div v-if="!isEditMode"
                 class="input ellipsis">({{ apply.timezone }}) {{ apply.timezoneName }}</div>
            <input v-else
                   id="timezone" type="text"
                   :readonly="true"
                   :value="'(' + apply.timezone + ') ' + apply.timezoneName">
          </div>
          <div class="input--wrap w50p">
            <label>{{ $t('common.startDate2') }}</label>
            <div class="input" v-if="!isEditMode">
              <i class="icon icon--calendar-input"></i>
              <span v-if="apply.startDate">{{ computedStartDate }}</span>
              <span v-else>{{ $t('common.instantlyStart') }}</span>
            </div>
            <div class="data__date" :class="$i18n.locale" v-else>
              <label for="startDateInstantly" :class="browserInfo.name">
                <input id="startDateInstantly" type="radio" name="startDate" value="true" :checked="!model.startDate"
                       @change="onDateOptionChange('startDate', false)"><i class="icon icon--radio-off"></i>
                <span>{{ $t('common.instantlyStart') }}</span>
              </label>
              <label for="startDateSelect" :class="browserInfo.name">
                <input id="startDateSelect" type="radio" name="startDate" value="false" :checked="model.startDate"
                       @change="onDateOptionChange('startDate', true)"><i class="icon icon--radio-off"></i>
                <span>{{ $t('common.selectDate') }}</span>
                <div v-if="model.startDate" class="datepicker--wrap data__start-date">
                  <input type="text"
                         readonly
                         :value="computedStartDate"
                         @click.stop.prevent="toggleDatePicker('start')">
                  <i class="icon icon--calendar-input"></i>
                  <date-picker v-if="showStartDatePicker"
                               :isShowTimezone="true"
                               :timezone="timezoneStr"
                               :value="computedStartDate"
                               :minDate="minStartDate"
                               :maxDate="maxStartDate"
                               @input="onCalendarDateChange('startDate', $event)"
                               @onCloseClick="showStartDatePicker = false"/>
                </div>
              </label>
            </div>
          </div>
          <div class="input--wrap w50p">
            <label>{{ $t('common.endDate2') }}</label>
            <div class="input" v-if="!isEditMode">
              <i class="icon icon--calendar-input"></i>
              {{ computedEndDate }}
            </div>
            <div class="data__date" v-else>
              <div class="datepicker--wrap data__end-date">
                <input type="text" readonly
                       :value="computedEndDate"
                       @click.stop.prevent="toggleDatePicker('end')">
                <i class="icon icon--calendar-input"></i>
                <date-picker v-if="showEndDatePicker"
                             :isShowTimezone="true"
                             :timezone="timezoneStr"
                             :value="computedEndDate"
                             :minDate="minEndDate"
                             @input="onCalendarDateChange('endDate', $event)"
                             @onCloseClick="showEndDatePicker = false"/>
              </div>
            </div>
          </div>
        </div>
        <div class="input--wrap">
          <label for="note">{{ $t('common.message') }}</label>
          <textarea v-if="isEditMode"
                    id="note" type="text"
                    :placeholder="$t('common.placeHolder.noMessage')"
                    v-model="model.message"></textarea>
          <div v-else-if="model.message"
               class="input textarea ellipsis"><pre v-html="model.message"></pre></div>
          <div v-else
               class="input textarea placeholder">{{ $t('common.placeHolder.noMessage') }}</div>
        </div>
      </div>
      <div class="detail__footer">
        <div v-if="!isEditMode">
          <ui-button
            @click="isEditMode = true">{{ $t('common.edit') }}</ui-button>
          <ui-button
            @click="$emit('onReject')">{{ $t('userInfo.pageManagement.reject.button') }}</ui-button>
          <ui-button :primary="true"
                     @click="$emit('onApprove')">{{ $t('userInfo.pageManagement.approve.button') }}</ui-button>
        </div>
        <div v-else>
          <ui-button
            @click="onCancelClick">{{ $t('common.cancel') }}</ui-button>
          <ui-button :primary="true"
                     @click="onSaveClick">{{ $t('common.save') }}</ui-button>
        </div>
      </div>
    </section>
  </content-box>
</template>

<script>
import { format, parse, addDays, startOfDay, endOfDay } from 'date-fns'
import { triggerClickEvent, browserInfo, dateFormatTimezone, tzOffsetDate } from '@/libs/utils'
import { getDialog } from '@/libs/vue-utils'
import { insertApply } from '@/api/apply'
import UiButton from '@/components/ui/UiButton'
import UiSelectbox from '@/components/ui/UiSelectbox'
import DatePicker from '@/components/date-picker'
import ContentBox from '../../ui/ContentBox'
import { mapState } from 'vuex'

const openDialog = getDialog('dialogType')

const DATE_FORAMT = 'YYYY-MM-DD'

export default {
  components: {
    ContentBox,
    UiButton,
    UiSelectbox,
    DatePicker
  },
  props: [
    'apply'
  ],
  computed: {
    ...mapState([
      'userData'
    ]),
    computedStartDate () {
      if (this.model.startDate && this.model.startDate.length > 10) {
        return dateFormatTimezone(this.model.startDate, this.apply.timezoneName)
      }
      return this.model.startDate
    },
    computedEndDate () {
      if (this.model.endDate && this.model.endDate.length > 10) {
        return dateFormatTimezone(this.model.endDate, this.apply.timezoneName)
      }
      return this.model.endDate
    },
    timezoneStr () {
      return `(${this.apply.timezone}) ${this.apply.timezoneName}`
    },
    minStartDate () {
      return addDays(tzOffsetDate(new Date(), this.apply.timezone), 1)
    },
    maxStartDate () {
      if (!this.model.endDate) {
        return null
      }
      return parse(this.computedEndDate)
    },
    minEndDate () {
      if (!this.model.startDate) {
        return tzOffsetDate(new Date(), this.timezone)
      }
      return parse(this.computedStartDate)
    },
    browserInfo () {
      return browserInfo
    }
  },
  data () {
    return {
      isEditMode: false,
      isConfirming: false,
      model: {
        pvLimit: null,
        startDate: null,
        endDate: null,
        message: null
      },
      pvLimitOptionList: [
        {
          value: 3000,
          text: '3,000'
        },
        {
          value: 5000,
          text: '5,000'
        },
        {
          value: 10000,
          text: '10,000'
        },
        {
          value: 20000,
          text: '20,000'
        },
        {
          value: 50000,
          text: '50,000'
        },
        {
          value: 0,
          text: this.$t('page.registration.optional.report.pvLimit.directInput')
        },
        {
          value: -1,
          text: this.$t('common.noLimit')
        }
      ],
      internalPvLimit: null,
      customPvLimit: 3000,
      showStartDatePicker: false,
      showEndDatePicker: false
    }
  },
  methods: {
    toggleDatePicker (type) {
      switch (type) {
        case 'start':
          if (!this.showStartDatePicker) {
            triggerClickEvent()
          }
          this.showStartDatePicker = !this.showStartDatePicker
          break
        case 'end':
          if (!this.showEndDatePicker) {
            triggerClickEvent()
          }
          this.showEndDatePicker = !this.showEndDatePicker
          break
      }
    },
    onDateOptionChange (dateType, value) {
      let dateValue = null

      if (value) {
        const now = new Date()

        if (dateType === 'startDate') {
          dateValue = addDays(startOfDay(now), 1)
        } else {
          if (this.startDate) {
            dateValue = endOfDay(addDays(parse(this.startDate), 6))
          } else {
            dateValue = endOfDay(addDays(now, 6))
          }
        }
        dateValue = format(dateValue, DATE_FORAMT)
      }
      this.model[dateType] = dateValue
    },
    onCalendarDateChange (dateType, value) {
      let dateValue = parse(value)

      if (dateType === 'startDate') {
        dateValue = startOfDay(dateValue)
      } else {
        dateValue = endOfDay(dateValue)
      }
      dateValue = format(dateValue, DATE_FORAMT)
      this.model[dateType] = dateValue
    },
    onPVLimitChange (value) {
      this.internalPvLimit = value
      this.model.pvLimit = value === 0 ? this.customPvLimit : value
    },
    onCancelClick () {
      this.isConfirming = true
      openDialog('dashboard.editCancel').then(result => {
        if (result) {
          this.isEditMode = false
        }
        this.isConfirming = false
      })
    },
    onSaveClick () {
      this.isConfirming = true
      openDialog('dashboard.saveApplies').then(result => {
        if (result) {
          this.onSave()
        }
        this.isConfirming = false
      })
    },
    onSave () {
      insertApply({
        id: this.apply._id,
        pvLimit: this.model.pvLimit,
        startDate: this.computedStartDate,
        endDate: this.computedEndDate,
        message: this.model.message
      }).then(result => {
        this.isEditMode = false
        this.apply.pvLimit = this.model.pvLimit
        this.apply.message = this.model.message
        this.apply.startDate = this.model.startDate
        this.apply.endDate = this.model.endDate
        this.customPvLimit = 3000
      })
    },
    reset () {
      this.model.pvLimit = this.apply.pvLimit
      this.model.message = this.apply.message
      this.model.startDate = this.apply.startDate
      this.model.endDate = this.apply.endDate

      const pvItem = this.pvLimitOptionList.find(item => {
        return item.value !== 0 && item.value === this.model.pvLimit
      })

      const pvLimit = pvItem ? pvItem.value : 0
      this.internalPvLimit = pvLimit

      if (this.internalPvLimit === 0) {
        this.customPvLimit = this.model.pvLimit
      }
    },
    checkCustomPvLimit () {
      const value = Number(this.customPvLimit)

      if (!value || isNaN(value)) {
        this.customPvLimit = 3000
      }
      this.model.pvLimit = this.customPvLimit
    }
  },
  watch: {
    isEditMode () {
      this.reset()
    }
  },
  created () {
    this.isEditMode = false
    this.reset()
  }
}
</script>

<style lang="scss" scoped="scoped">
.page_management__detail {
  position: relative;

  .btn-close {
    position: absolute;
    top: -46px;
    right: 12px;
    z-index: 3;
  }

  .detail__header {
    position: absolute;
    top: -58px;
    left: 30px;
    background: #ffffff;
    width: calc(100% - 60px);
    height: 58px;
    z-index: 2;
    box-sizing: border-box;

    h4 {
      color: #2f2f2f;
      line-height: 1.47;
      font-weight: bold;
      font-size: 15px;
      margin: 25px 0 0 0;
    }
  }

  .detail__body {
    padding: 0 30px;
    margin: 58px 0 85px 0;
    max-height: calc(100vh - 250px);
    overflow-y: auto;
  }

  .detail__footer {
    position: absolute;
    bottom: -85px;
    left: 30px;
    background: #ffffff;
    width: calc(100% - 60px);
    height: 85px;
    text-align: center;
    z-index: 2;

    .ui-btn {
      margin: 22px 3px 0 2px;
      width: 94px;
    }
  }

  .line {
    border-top: 1px solid #bbbbbb;
    padding-top: 20px;
  }

  .input--wrap {
    width: 100%;
    display: inline-block;
    margin-bottom: 20px;
    vertical-align: top;

    &.w50p {
      width: calc(50% - 9px);
      margin-right: 18px;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    &.w33p {
      width: calc(33.333333% - 12px);
      margin-right: 18px;

      &:nth-child(3n) {
        margin-right: 0;
      }
    }

    &.w66p {
      width: calc(66.666666% - 6px);
      margin-right: 18px;

      &:nth-child(2n) {
        margin-right: 0;
      }
    }

    &.single-line {
      label {
        display: inline-block;
      }

      .input {
        display: inline-block;
        width: auto;
        padding: 0 0 0 10px;
      }
    }

    label {
      display: block;
      font-size: 13px;
      font-weight: bold;
      line-height: 1;
      color: #767676;
      padding: 3px 10px;
    }

    textarea,
    input[type=text],
    input[type=number],
    input[type=password] {
      margin-top: 5px;
      height: 38px;
      border-radius: 6px;
      border: solid 1px #bbbbbb;
      background-color: #ffffff;
      padding: 12px 35px 12px 12px;
      box-sizing: border-box;
      font-size: 14px;
      color: #2f2f2f;
      width: 100%;
      resize: none;

      &.error {
        border-color: $errorColor;
      }
    }

    input[type=number] {
      padding: 12px;
      margin-right: 5px;
      width: calc(100% - 25px)
    }

    textarea {
      height: 88px;
      font-size: 13px;
      padding: 8px 12px;
    }

    .ui_select {
      margin-top: 5px;
    }

    .input {
      margin-top: 5px;
      height: 38px;
      border: solid 1px transparent;
      padding: 12px 0 12px 9px;
      box-sizing: border-box;
      font-size: 14px;
      color: #2f2f2f;
      width: 100%;

      &.textarea {
        font-size: 13px;
      }

      &.readonly {
        padding: 12px;
        border-radius: 6px;
        border-color: #d7d7d7;
        background-color: #e6e6e6;
        cursor: not-allowed;
        color: #999999;
      }

      &.placeholder {
        color: #bbbbbb;
      }

      i {
        vertical-align: middle;
        margin: 0 3px 0 0;
        transform: translateY(-2px);
      }
    }

    textarea[readonly],
    input[readonly] {
      border: solid 1px #d7d7d7;
      background-color: #e6e6e6;
      color: #999999;
      cursor: not-allowed;
    }

    .data__date {
      input[readonly] {
        border: solid 1px #bbbbbb;
        background-color: #fff;
        cursor: pointer;
      }

      input[type=radio] {
        visibility: hidden;
        width: 0;
        height: 0;
      }

      label {
        display: inline-block;
        padding: 0;
        margin-top: 17px;
        position: relative;

        .icon {
          margin-right: 5px;
          vertical-align: middle;
          transform: translateY(-2px);
        }

        span {
          display: inline-block;
          width: 60px;
        }

        &[for=startDateInstantly] {
          span {
            width: 65px;
          }

          &.ie {
            span {
              font-weight: normal;
              letter-spacing: -1px;
            }
          }
        }

        &[for=startDateSelect] {
          width: 88px;

          &.ie {
            width: 83px;

            .datepicker--wrap {
              width: 114px;
              right: -117px;

              input {
                padding-left: 32px;
                padding-right: 0;
              }
            }

            span {
              font-weight: normal;
              letter-spacing: -1px;
            }
          }
        }

        .datepicker--wrap {
          position: absolute;
          top: -5px;
          right: -120px;
          z-index: 10;

          .icon {
            transform: translateY(-7px);
            vertical-align: middle;
          }

          input {
            vertical-align: middle;
          }
        }
      }

      &.en {
        label {
          margin-top: 12px;

          .icon {
            transform: translateY(-7px);
          }

          &[for=startDateInstantly] {
            span {
              width: 80px;
            }
          }

          .datepicker--wrap {
            top: 0;
            right: -108px;
            width: 120px;
          }

          &[for=startDateSelect] {
            &.ie {
              width: 83px;
            }

            .datepicker--wrap {
              right: -103px;
            }
          }
        }
      }
    }
  }

  .datepicker--wrap {
    position: relative;

    &.data__start-date {
      width: 123px;
      display: inline-block;
      margin-left: -10px;
      transform: translateY(-5px);
      height: 38px;
      margin-top: -7px;
    }

    & > .icon {
      position: absolute;
      top: calc(50% + 3px);
      left: 9px;
      transform: translateY(-50%);
    }

    & > input[type=text] {
      width: 100%;
      height: 38px;
      line-height: 13px;
      border-radius: 6px;
      background-color: #ffffff;
      border: 1px solid #bbbbbb;
      box-sizing: border-box;
      text-align: left;
      font-size: 14px;
      color: #2f2f2f;
      padding-left: 35px;
      padding-right: 12px;

      &:focus {
        border-color: #289eef;
      }
    }

    .date_picker {
      top: -267px;
      left: 50%;
    }
  }
}
</style>
